export default {
    title: 'Delete user',
    reallyDelete: 'Do you really want to delete the selected users?',
    deleteAction: 'Delete no User | Delete one User | Delete {count} Users',
    deletedUsers: 'The users have been deleted'
}